import { Sidebar } from './Sidebar';
import { BreadcrumbBar } from './BreadcrumbBar';
import { BreadcrumbLocationSync } from '@/lib/breadcrumbs/BreadcrumbLocationSync';

interface MainLayoutProps {
    children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
    return (
        <div className="flex h-screen bg-gray-50">
            <Sidebar />
            <main className="relative flex flex-1 flex-col overflow-y-auto bg-gray-50">
                <BreadcrumbLocationSync />
                <BreadcrumbBar />
                <div className="max-w-7xl mx-auto w-full p-8">{children}</div>
            </main>
        </div>
    );
}
